module.exports = __webpack_public_path__ + "static/media/galeria_elo_08.f4ac02b9.jpg";